import { __ } from 'i18n';
import { api } from "@converse/headless/core";
import { html } from "lit";
import { resetElementHeight } from '../utils.js';


export default (o) => {
    const label_message = o.composing_spoiler ? __('Hidden message') : __('Message');
    const label_spoiler_hint = __('Optional hint');
    const show_send_button = api.settings.get('show_send_button');

    return html`
        <div>
            <form class="sendXMPPMessage">
                <div class="suggestion-box">
                <span class="hidden-desktop show-message-option">+</span>
                <textarea
                    autofocus
                    type="text"
                    @drop=${o.onDrop}
                    @input=${resetElementHeight}
                    @keydown=${o.onKeyDown}
                    @keyup=${o.onKeyUp}
                    @paste=${o.onPaste}
                    @change=${o.onChange}
                    class="chat-textarea
                        ${ show_send_button ? 'chat-textarea-send-button' : '' }
                        ${ o.composing_spoiler ? 'spoiler' : '' }"
                    placeholder="Nouveau message">${ o.message_value || '' }</textarea>
                <button type="submit" class="btn send-button fa fa-paper-plane altelis-custom-send-message" title="Envoyer Message"><span>Envoyer</span></button>
                </div>
            </form>
        </div>
    `;
}
